import { TextButton } from '@shape-ds/components';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import './AttachedEvidenceButton.scss';
import OilBarrelOutlinedIcon from '@mui/icons-material/OilBarrelOutlined';
import WaterIcon from '@mui/icons-material/Water';
import { AnalysisType } from './AnalysisButtons';

type AttachedEvidenceButtonProps = {
  btnType: AnalysisType;
  btnText: string;
  handleBtnClick: () => void;
  handleBtnDelete: () => void;
};

export const AttachedEvidenceButton = ({
  btnType,
  btnText,
  handleBtnClick,
  handleBtnDelete,
}: AttachedEvidenceButtonProps) => {
  return (
    <div className="attached-evidence-button-container">
      <TextButton
        className="attached-evidence-button"
        onClick={handleBtnClick}
        startIcon={
          btnType === 'OIL_ANALYSIS' ? (
            <OilBarrelOutlinedIcon className="attached-evidence-button-icon-oil" />
          ) : (
            <WaterIcon className="attached-evidence-button-icon-water" />
          )
        }
      >
        {btnText}
      </TextButton>
      <IconButton onClick={handleBtnDelete} size="small">
        <FontAwesomeIcon icon={faTrashCan} className="attached-evidence-button-delete-icon" />
      </IconButton>
    </div>
  );
};
